import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MANIFESTO, SERVICES } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 50 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] } }),
};

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="metodo" ref={ref} className="relative bg-brand-surface py-24 lg:py-36 overflow-hidden" data-testid="manifesto-section">
      {/* giant ghost number */}
      <motion.span
        style={{ y }}
        className="pointer-events-none absolute -right-10 top-10 font-anton text-[42vw] leading-none text-white/[0.02] select-none"
      >
        NG
      </motion.span>

      <div className="relative max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="mb-20 max-w-3xl">
          <p className="font-outfit text-xs tracking-[0.3em] uppercase text-brand-red font-bold mb-4">— Il metodo New Graphic</p>
          <h2 className="font-anton uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight">
            Perché sceglierci
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-brand-border border border-brand-border">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.num}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              data-testid={`manifesto-${m.num}`}
              className="group bg-brand-dark p-10 lg:p-12 hover:bg-brand-surface-2 transition-colors duration-500"
            >
              <span className="font-anton text-brand-red text-6xl lg:text-7xl block mb-8 group-hover:translate-x-2 transition-transform duration-500">
                {m.num}
              </span>
              <h3 className="font-outfit font-semibold text-xl lg:text-2xl mb-4 uppercase tracking-tight">{m.title}</h3>
              <p className="font-manrope font-light text-neutral-400 leading-relaxed">{m.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-20">
          {[
            { n: "10+", l: "Anni di esperienza" },
            { n: "500+", l: "Veicoli rivestiti" },
            { n: "100%", l: "Pellicole certificate" },
            { n: `0${SERVICES.length}`, l: "Servizi su misura" },
          ].map((s, i) => (
            <motion.div
              key={i}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="border-l-2 border-brand-red pl-5"
              data-testid={`stat-${i}`}
            >
              <div className="font-anton text-4xl lg:text-5xl">{s.n}</div>
              <div className="font-outfit text-xs uppercase tracking-widest text-neutral-500 mt-2">{s.l}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
